/**
 * House of Prancer — desktop mega-menu close delay.
 *
 * Horizon closes an open dropdown the instant the pointer leaves the top-level
 * <li> (on:pointerleave -> deactivate). The submenu columns sit at the page's
 * left edge, under the logo, so a diagonal move from "Shop" toward "Pillows"
 * exits the <li> sideways and the menu snaps shut before the link is reached.
 *
 * This wraps HeaderMenu.prototype.deactivate so a pointerleave waits
 * CLOSE_DELAY_MS before closing, and is cancelled if the pointer comes back to
 * the item (or its submenu) or another top-level item has already taken over.
 * Keyboard/focus (blur) behaviour is untouched.
 */
(function () {
  var CLOSE_DELAY_MS = 400;

  customElements.whenDefined('header-menu').then(function () {
    var HeaderMenu = customElements.get('header-menu');
    if (!HeaderMenu) return;
    var original = HeaderMenu.prototype.deactivate;
    if (typeof original !== 'function' || original.__hopPatched) return;

    function deactivateWithDelay(event) {
      var self = this;
      if (!event || event.type !== 'pointerleave') return original.call(self, event);

      var item = event.target; // the top-level <li class="menu-list__list-item">
      if (!(item instanceof Element)) return original.call(self, event);

      clearTimeout(self.__hopCloseTimer);
      self.__hopCloseTimer = setTimeout(function () {
        self.__hopCloseTimer = undefined;
        // Pointer returned to the item or its submenu: keep it open.
        if (item.matches(':hover')) return;
        // Another item is now active (or it was closed by Escape/toggle): nothing to do.
        if (!item.querySelector('[aria-expanded="true"]')) return;
        original.call(self, event);
      }, CLOSE_DELAY_MS);
    }

    deactivateWithDelay.__hopPatched = true;
    HeaderMenu.prototype.deactivate = deactivateWithDelay;
  });
})();
